// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.shared.patient.preferences.PatientCommunicationEligibilityResponse */
/* istanbul ignore next */
@GandalfModel
export class PatientCommunicationEligibilityResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	message!: string | null;

	@GandalfConstantDecorator(constants.PatientCommunicationEligibility)
	@GandalfProperty({ designType: constants.PatientCommunicationEligibility })
	patientCommunicationEligibility!: constants.PatientCommunicationEligibility | null;

}
